module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 146
// module chunks = 0